const theme = {
  bg: '#fbfbf5',
  primary: '#c60664',
  text: '#1a1a1a',
};

export default theme;
